import { Classes } from '@blueprintjs/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  flex-direction: column;
  width: 72px;
  min-height: 72px;
  margin-right: 0 !important;
  padding: 10px 5px;
  border-radius: 0;
  font-size: 12px;
  text-align: center;

  > * {
    margin-right: 0;
  }

  .bp5-icon {
    color: inherit;
  }
`;

const SectionTab = ({ active, children, name, onClick }) => (
  <StyledButton
    className={classNames({
      [Classes.BUTTON]: true,
      [Classes.MINIMAL]: true,
      [Classes.ACTIVE]: active,
      [Classes.INTENT_PRIMARY]: active,
    })}
    onClick={onClick}
    type="button"
  >
    <div>{children}</div>
    <div>{name}</div>
  </StyledButton>
);

SectionTab.propTypes = {
  active: PropTypes.bool.isRequired,
  children: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SectionTab;
